import BasePage from './pages/BasePage/BasePage';

const routes = [
  {
    name: 'Base Page', 
    path: '*', 
    element: <BasePage />,
  },
];

export default routes;